<template>
  <!-- プレオプトインダイアログ(カスタマイズあり)のサンプル -->
  <div :class="optinDialogClass" :style="optinDialogStyle">
    <div class="coins-optin-dialog-icon">
      <img
        style="vertical-align: top !important"
        :src="dialogValues.icon"
      />
    </div>
    <div :class="textBoxClass">
      <div class="coins-close-button" :style="closeCrossStyle" @click="$emit('close')">
        <span></span>
      </div>
      <span>{{ dialogValues.message }}</span>
    </div>
    <div class="coins-optin-dialog-button-box" :style="buttonBoxStyle">
      <button :class="closeButtonClass" :style="closeButtonStyle" @click="$emit('close')">
        {{ dialogValues.customStyle.close.text }}
      </button>
      <button :class="buttonClass" :style="buttonStyle" @click="$emit('close')">
        {{ dialogValues.button }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialogValues: {
      icon: String,
      message: String,
      button: String,
      customStyle: {
        vertical: String,
        horizontal: String,
        size: String,
        design: Number,
        buttonType: Number,
        close: {
          type: String,
          text: String,
        },
      },
    },
  },
  emits: ["close"],
  data() {
    return {
      showSampleDialog: true,
    };
  },
  computed: {
    optinDialogClass() {
      const design = `coins-optin-dialog-design-${this.dialogValues.customStyle.design}`;
      return this.dialogValues.customStyle.vertical === 'top'
        ? `coins-optin-dialog-top ${design}`
        : `coins-optin-dialog ${design}`;
    },
    optinDialogStyle() {
      return {
        top:
          this.dialogValues.customStyle.vertical === 'top'
            ? '10px'
            : null,
        bottom:
          this.dialogValues.customStyle.vertical === 'bottom'
            ? '10px'
            : null,
        left:
          this.dialogValues.customStyle.horizontal === 'left'
            ? '10px'
            : this.dialogValues.customStyle.horizontal === 'center'
              ? '0px'
              : null,
        right:
          this.dialogValues.customStyle.horizontal === 'right'
            ? '10px'
            : this.dialogValues.customStyle.horizontal === 'center'
              ? '0px'
              : null,
        margin:
          this.dialogValues.customStyle.horizontal === 'center'
            ? '0 auto'
            : null,
        padding:
          this.dialogValues.customStyle.size === 'large'
            ? '18px'
            : null,
      };
    },
    closeCrossStyle() {
      return {
        display:
          this.dialogValues.customStyle.close.type === 'cross'
            ? 'block'
            : 'none',
        top:
          this.dialogValues.customStyle.vertical === 'top'
            ? '4px'
            : 'auto',
        bottom:
          this.dialogValues.customStyle.vertical === 'bottom' &&
          this.dialogValues.customStyle.size === 'large'
            ? '140px'
            : this.dialogValues.customStyle.vertical === 'bottom' &&
              this.dialogValues.customStyle.size === 'small'
              ? '56px'
              : 'auto',
      };
    },
    textBoxClass() {
      return this.dialogValues.customStyle.size === 'large'
        ? 'coins-optin-dialog-text-box-large'
        : 'coins-optin-dialog-text-box';
    },
    buttonBoxStyle() {
      return {
        position:
          this.dialogValues.customStyle.size === 'small'
            ? 'absolute'
            : 'relative',
        top:
          this.dialogValues.customStyle.size === 'small' &&
          this.dialogValues.customStyle.vertical === 'top'
            ? '48px'
            : null,
        bottom:
          this.dialogValues.customStyle.size === 'small' &&
          this.dialogValues.customStyle.vertical === 'bottom'
            ? '8px'
            : null,
        right:
          this.dialogValues.customStyle.size === 'small'
            ? '24px'
            : null,
        height:
          this.dialogValues.customStyle.size === 'small'
            ? '28px'
            : '48px',
      };
    },
    closeButtonClass() {
      return this.dialogValues.customStyle.buttonType === 2
        ? 'coins-optin-dialog-close-button-type-2'
        : this.dialogValues.customStyle.buttonType === 3
          ? 'coins-optin-dialog-close-button-type-3'
          : 'coins-optin-dialog-close-button';
    },
    buttonClass() {
      return this.dialogValues.customStyle.buttonType === 2
        ? 'coins-optin-dialog-button-type-2'
        : this.dialogValues.customStyle.buttonType === 3
          ? 'coins-optin-dialog-button-type-3'
          : 'coins-optin-dialog-button';
    },
    closeButtonStyle() {
      return {
        ...this.buttonStyle,
        display:
          this.dialogValues.customStyle.close.type === 'cross'
            ? 'none'
            : 'block',
      };
    },
    buttonStyle() {
      return this.dialogValues.customStyle.size === 'large'
        ? {
          padding: '12px 24px',
          fontSize: 'medium',
        }
        : {
          padding: '4px 12px',
          fontSize: 'small',
        };
    },
  },
  methods: {
    toggleShowDialog: function () {
      this.showSampleDialog = !this.showSampleDialog;
    },
  },
};
</script>

<style scoped>
@keyframes CoinsShowAnimationFromBottom {
    0% {
        opacity: 0;
        transform: translateY(100px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes CoinsHideAnimationToBottom {
    0% {
        opacity: 1;
        transform: translateY(0);
    }
    100% {
        opacity: 0;
        transform: translateY(100px);
    }
}

@keyframes CoinsShowAnimationFromTop {
    0% {
        opacity: 0;
        transform: translateY(-100px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes CoinsHideAnimationToTop {
    0% {
        opacity: 1;
        transform: translateY(0);
    }
    100% {
        opacity: 0;
        transform: translateY(-100px);
    }
}

.coins-close-button {
    display: inline-block;
    width: 24px;
    height: 24px;
    position: absolute;
    cursor: pointer;
    border-radius: 50%;
    right: 4px;
}
.coins-close-button span::before,
.coins-close-button span::after {
    display: block;
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 84%;
    height: 10%;
    margin: -8% 0 0 -42%;
    background: gray;
}
.coins-close-button span::before {
    transform: rotate(-45deg);
}
.coins-close-button span::after {
    transform: rotate(45deg);
}

.coins-optin-dialog {
    z-index: 9999;
    position: fixed;
    background-color: white;
    width: 500px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    overflow: hidden;
    animation-name: CoinsShowAnimationFromBottom;
    animation-duration: 0.5s;
}

.coins-optin-dialog-top {
    z-index: 9999;
    position: fixed;
    background-color: white;
    width: 500px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    overflow: hidden;
    animation-name: CoinsShowAnimationFromTop;
    animation-duration: 0.5s;
}

.coins-optin-dialog-top:hover,
.coins-optin-dialog:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

.coins-optin-dialog-design-2 {
    border: solid 2px #000000;
}

.coins-optin-dialog-design-3 {
    border: solid 2px #000000;
    border-radius: 16px;
}

@media screen and (max-width: 600px) {
    .coins-optin-dialog-top {
        width: 100%;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
    }
    .coins-optin-dialog-top.coins-optin-dialog-design-2 {
        border: none;
        border-bottom: solid 2px #000000;
    }
    .coins-optin-dialog-top.coins-optin-dialog-design-3 {
        border-top: 0;
        border-radius: 0 0 16px 16px;
    }
    .coins-optin-dialog {
        width: 100%;
        bottom: 0 !important;
        left: 0 !important;
        right: 0 !important;
    }
    .coins-optin-dialog.coins-optin-dialog-design-2 {
        border: none;
        border-top: solid 2px #000000;
    }
    .coins-optin-dialog.coins-optin-dialog-design-3 {
        border-bottom: 0;
        border-radius: 16px 16px 0 0;
    }
}

.coins-optin-dialog-icon {
    display: inline-block;
    vertical-align: top;
}

.coins-optin-dialog-icon > img {
    width: 84px;
    height: 84px;
}

.coins-optin-dialog-text-box,
.coins-optin-dialog-text-box-large {
    display: inline-block;
    word-wrap: break-word;
    vertical-align: top;
    max-width: 70%;
}

.coins-optin-dialog-text-box > span,
.coins-optin-dialog-text-box-large > span {
    display: block;
    margin-top: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: medium;
    color: gray;
    width: 380px;
}

@media screen and (max-width: 600px) {
    .coins-optin-dialog-text-box > span {
        width: auto;
        font-size: small;
        margin-bottom: 0px;
        margin-top: 4px;
    }
    .coins-optin-dialog-text-box-large > span {
        width: auto;
        font-size: medium;
        margin-bottom: 0px;
        margin-top: 4px;
    }
}

.coins-optin-dialog-button-box {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
}

.coins-optin-dialog-close-button {
    border: 1px solid rgba(0, 0, 0, 0.25);
    cursor: pointer;
    appearance: none;
    background-color: rgba(0, 0, 0, 0);
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.4);
    min-width: 80px;
    transition: background-color 0.2s ease;
}

.coins-optin-dialog-close-button:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.coins-optin-dialog-button {
    border: none;
    cursor: pointer;
    outline: none;
    appearance: none;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    color: gray;
    min-width: 80px;
    transition: background-color 0.2s ease;
}

.coins-optin-dialog-button:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

.coins-optin-dialog-close-button-type-2 {
    border: 1px solid #0d6dfc;
    cursor: pointer;
    appearance: none;
    background-color: rgba(0, 0, 0, 0);
    border-radius: 4px;
    color: #0d6dfc;
    min-width: 80px;
    transition: background-color 0.2s ease;
}

.coins-optin-dialog-close-button-type-2:hover {
    background-color: #0d6dfc12;
}

.coins-optin-dialog-button-type-2 {
    border: none;
    cursor: pointer;
    outline: none;
    appearance: none;
    background-color: #0d6dfc;
    border-radius: 4px;
    color: #ffffff;
    min-width: 80px;
    transition: background-color 0.2s ease;
}

.coins-optin-dialog-button-type-2:hover {
    background-color: #0a57c9;
}

.coins-optin-dialog-close-button-type-3 {
    border: 1px solid #1a8754;
    cursor: pointer;
    appearance: none;
    background-color: rgba(0, 0, 0, 0);
    border-radius: 4px;
    color: #1a8754;
    min-width: 80px;
    transition: background-color 0.2s ease;
}

.coins-optin-dialog-close-button-type-3:hover {
    background-color: #1a875412;
}

.coins-optin-dialog-button-type-3 {
    border: none;
    cursor: pointer;
    outline: none;
    appearance: none;
    background-color: #1a8754;
    border-radius: 4px;
    color: #ffffff;
    min-width: 80px;
    transition: background-color 0.2s ease;
}

.coins-optin-dialog-button-type-3:hover {
    background-color: #146b41;
}
</style>
